import React from 'react';
import './shimmer.css';
import { useTheme } from '../../../styles/ThemeProvider';

export const SkeletonKpi = () => {
  const { theme } = useTheme();
  return (
    <div style={{
      background: theme.color.surface,
      border: `1px solid ${theme.color.border}`,
      borderRadius: theme.radius.md,
      padding: theme.space.lg,
      boxShadow: theme.shadow.sm,
    }}>
      <div className="analytics-skeleton" style={{ height: 12, width: '60%', marginBottom: theme.space.md }} />
      <div className="analytics-skeleton" style={{ height: 32, width: '80%', marginBottom: theme.space.sm }} />
      <div className="analytics-skeleton" style={{ height: 10, width: '40%' }} />
    </div>
  );
};
